(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lux-gallery"] && !Shopify.designMode) return;
  try {
    
  class LuxShuffle extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const grid = this.querySelector('.lux-gallery');
      if (!grid) return;
      const items = Array.from(grid.children);
      for (let i = items.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        grid.appendChild(items[j]);
        items.splice(j, 1);
      }
    }
  }

  if (!customElements.get('lux-shuffle')) {
    customElements.define('lux-shuffle', LuxShuffle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lux-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class LuxHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.lux-slider__slide'));
      this.dots = Array.from(this.querySelectorAll('.lux-slider__dot'));
      this.index = 0;
      this.timer = null;

      if (this.slides.length < 2) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.show(Number(dot.dataset.goto));
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.restart());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.restart());

      this.restart();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(next) {
      this.slides.forEach((slide, i) => {
        const active = i === next;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-pressed', i === next ? 'true' : 'false');
      });
      this.index = next;
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      if (this.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const wait = Number(this.dataset.interval) || 5000;
      this.timer = setInterval(() => {
        this.show((this.index + 1) % this.slides.length);
      }, wait);
    }
  }

  if (!customElements.get('lux-hero-slider')) {
    customElements.define('lux-hero-slider', LuxHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class LuxGridDensity extends HTMLElement {
    constructor() {
      super();
      this.grid = null;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-cols]');
        if (button) this.apply(button.dataset.cols, true);
      });
    }

    connectedCallback() {
      this.grid = document.getElementById('product-grid');
      let saved = null;
      try {
        saved = localStorage.getItem('lux-grid-density');
      } catch (error) {
        saved = null;
      }
      this.apply(saved || this.dataset.default || '4', false);
    }

    apply(cols, persist) {
      if (!this.grid) this.grid = document.getElementById('product-grid');
      if (!this.grid) return;
      this.grid.style.setProperty('--lux-cols', cols);
      this.querySelectorAll('[data-cols]').forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.cols === String(cols));
      });
      if (persist) {
        try {
          localStorage.setItem('lux-grid-density', cols);
        } catch (error) {
          /* private mode: choice simply is not remembered */
        }
      }
    }
  }

  if (!customElements.get('lux-grid-density')) {
    customElements.define('lux-grid-density', LuxGridDensity);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class LuxNegotiate extends HTMLElement {
    connectedCallback() {
      this.wireToggle();
      this.showConfirmation();
      this.link = this.querySelector('[data-neg="whatsapp"]');
      if (!this.link) return;
      this.fields = {
        offer: this.querySelector('[data-neg="offer"]'),
        phone: this.querySelector('[data-neg="phone"]'),
        note: this.querySelector('[data-neg="note"]'),
      };
      this.base = this.link.getAttribute('href');
      this.addEventListener('input', () => this.build());
      this.build();
    }

    wireToggle() {
      // The trigger lives inside the product form, so it is an anchor rather
      // than a button. With JS we intercept it and toggle in place; without JS
      // the href still reveals the panel through its :target rule.
      this.trigger = document.querySelector('[data-lux-negotiate-open][href="#' + this.id + '"]');
      if (this.trigger) {
        this.trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggle(!this.classList.contains('is-open'));
        });
      }
      this.querySelectorAll('[data-lux-negotiate-close]').forEach((el) => {
        el.addEventListener('click', () => this.toggle(false));
      });
    }

    toggle(open) {
      this.classList.toggle('is-open', open);
      if (this.trigger) this.trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        const first = this.querySelector('input, textarea');
        if (first) first.focus();
      }
    }

    showConfirmation() {
      const box = this.querySelector('.lux-takeover');
      if (!box) return;

      // Shopify puts the sending form's id in the hash, so a different form on
      // this page having been submitted means this confirmation is not ours.
      const anchor = '#' + box.dataset.anchor;
      if (window.location.hash && window.location.hash !== anchor) {
        box.remove();
        return;
      }

      document.body.classList.add('overflow-hidden');
      const ok = box.querySelector('.lux-takeover__ok');
      if (ok) ok.focus();

      const target = box.dataset.return;
      const counter = box.querySelector('[data-count]');
      let left = parseInt(box.dataset.seconds, 10);
      if (!left || !counter) return;

      this.timer = setInterval(() => {
        left -= 1;
        counter.textContent = left > 0 ? left : 0;
        if (left <= 0) {
          clearInterval(this.timer);
          window.location.href = target;
        }
      }, 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      document.body.classList.remove('overflow-hidden');
    }

    build() {
      const offer = this.fields.offer && this.fields.offer.value.trim();
      const phone = this.fields.phone && this.fields.phone.value.trim();
      const note = this.fields.note && this.fields.note.value.trim();

      let text = 'Hi LuxuryHunts, I would like to make an offer on ' + this.dataset.product + '.';
      if (offer) text += ' My offer: ' + offer + '.';
      if (phone) text += ' You can reach me on ' + phone + '.';
      if (note) text += ' ' + note;
      text += ' ' + this.dataset.url;

      this.link.setAttribute('href', this.base + '?text=' + encodeURIComponent(text));
    }
  }

  if (!customElements.get('lux-negotiate')) {
    customElements.define('lux-negotiate', LuxNegotiate);
  }

  } catch(e) { console.error(e); }
})();
})();
